import runtimeConfig from '../config/runtimeConfig';

const envConfigKeyPrefix = "REACT_APP";
const envConfig = process.env as Readonly<Record<string, string | undefined>>;
const envName = envConfig.NODE_ENV;

export const isDevelopmentEnv = () => envName?.toLowerCase() === 'development';
export const isDevOrUat = () => {

    if (isDevelopmentEnv()) return true;

    const domain = ((window || {})?.location?.host) || '';
    const webEnvsAffixes = ['localhost:', '-uat.'];
    const isWebDevEnv = webEnvsAffixes?.some(x => domain.includes(x));

    return isWebDevEnv;
};

const getEnvConfigKey = (key: string, prefix: string): string => {
    key = key.toUpperCase().replace(new RegExp("-", 'g'), "_");
    return [prefix, key].filter(x => !!x).join("_");
};


const getEnvConfig = (key: string, fallback?: string, prefix = envConfigKeyPrefix) => {

    const publicConfigValues: Readonly<Record<string, string>> = {
        REACT_APP_DIP_BASE_URL: runtimeConfig.dipBaseUrl,
        REACT_APP_DIP_CLIENT_ID: runtimeConfig.dipClientId,
        REACT_APP_AUDIENCE: runtimeConfig.audience,
        REACT_APP_API_BASE_URL: runtimeConfig.apiBaseUrl,
        REACT_APP_TERMS_OF_USE_URL: runtimeConfig.termsOfUseUrl,
        REACT_APP_PRIVACY_POLICY_URL: runtimeConfig.privacyPolicyUrl,
        REACT_APP_YOUR_PROFILE_URL: runtimeConfig.profileUrl,
        REACT_APP_POWER_SOURCE_URL: runtimeConfig.powerSourceUrl,
        REACT_APP_PLUS1_FORUM_URL: runtimeConfig.plus1ForumUrl,
    };

    let configKey = getEnvConfigKey(key, prefix);

    let val = publicConfigValues[configKey] ?? envConfig[configKey] ?? fallback;

    if (!val) {
        return '';
    }
    return val;
};

export default class EnvConfigHelper {

    static envConfig: Readonly<Record<string, string | undefined>> = envConfig;
    static envName = envName;
    static get = getEnvConfig;
}
